"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.itsSchema = void 0;
const yup = __importStar(require("yup"));
const its_modifications_schema_1 = require("../its-modifications/its-modifications.schema");
exports.itsSchema = yup.object().shape({
    id: yup.string().notRequired(),
    details: yup.object().shape({
        as_of: yup.number(),
        crew_position: yup.string(),
        grade: yup.string(),
        name: yup.string().required(),
        pcn: yup.string(),
        physical_due_date: yup.number(),
        physiological_due_date: yup.number(),
        prepared: yup.number(),
        records_view_due_date: yup.number(),
        rpa_physical_due_date: yup.number(),
        ssan: yup.string(),
        unit: yup.string(),
    }),
    table: yup.array().of(yup.object().shape({
        acc: yup.string(),
        accomp: yup.number(),
        data_in_phase: yup.number(),
        data_last_accomp: yup.number(),
        due_data: yup.number(),
        ovedue: yup.string(),
        pgm: yup.string(),
        qualification: yup.string(),
        rem: yup.number(),
        req: yup.number(),
        rest_code: yup.string(),
        task_id: yup.string().required(),
        task_name: yup.string().required(),
        wvd: yup.string(),
    })),
    userId: yup.string().required(),
    squadronId: yup.string().required(),
    squadronName: yup.string().required(),
    createdAt: yup.number().required(),
    updatedAt: yup.number().required(),
    userModifications: its_modifications_schema_1.itsModificationsSchema.notRequired(),
});
